import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import { ThemeProvider, useTheme } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const ThemedToasts = () => {
  const { theme } = useTheme();
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme}
    />
  );
};

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <ThemedToasts />
    </ThemeProvider>
  </React.StrictMode>
);

